import { Coins } from "lucide-react";
import { Button } from "../ui/button";

export const LowCreditNudge = ({ cost, left, onBuy }) => {
  if (left == null || left >= cost) return null;
  return (
    <div data-testid="ugc-low-credit-nudge"
      className="mt-3 flex items-center justify-between gap-3 rounded-2xl border border-amber-400/30 bg-amber-500/10 px-4 py-3">
      <p data-testid="ugc-low-credit-text" className="text-sm text-amber-100">
        This ad costs {cost} credits and you have {left} left.
      </p>
      <Button data-testid="ugc-buy-credits-btn" onClick={onBuy}
        className="shrink-0 rounded-full bg-amber-400 font-semibold text-black hover:bg-amber-300">
        <Coins className="mr-2 h-4 w-4" />
        Buy credits
      </Button>
    </div>
  );
};
